import React from 'react';
import { ROUTES } from '../../../constants';

function OrderTrackingLink() {
  return (
    <a
      data-automation-id="backToTrackYourOrder"
      className="u__default-link"
      href={ROUTES.PATH.ORDER_TRACKING}
    >
      Back to Track Your Order
    </a>
  );
}

export default OrderTrackingLink;
